import { Component } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Inject } from '@angular/core';

@Component({
    selector: 'nh-largeData',
    templateUrl: './large-data.component.html',
    styleUrls: ['./large-data.component.scss'],
    standalone: false
})
export class LargeDataComponent {
    constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
    private dialogRef: MatDialogRef<LargeDataComponent>
  ) {}

  close() {
    this.dialogRef.close();
  }
}